module.exports = __webpack_public_path__ + "1209a3c29f22d75f1fbe2d641d573f24.png";